import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home as HomeIcon, ShoppingBag } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12 bg-white" data-testid="not-found-page">
      <div className="max-w-md text-center">
        <div className="text-overline text-[#FF5722] mb-3">Oops</div>
        <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-[#111111] mb-4">404</h1>
        <p className="text-zinc-600 mb-8">
          We couldn&apos;t find this page. The URL may be incorrect, or the page no longer exists.
          <br className="hidden sm:inline" />
          Try one of the links below:
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home"
            className="inline-flex items-center justify-center gap-2 bg-[#FF5722] text-white font-bold px-6 h-12 hover:bg-[#FF5722] transition-colors"
          >
            <HomeIcon size={16} /> Home
          </Link>
          <Link
            to="/shop"
            data-testid="not-found-shop"
            className="inline-flex items-center justify-center gap-2 border-2 border-zinc-300 text-[#111111] font-bold px-6 h-12 hover:bg-orange-600 hover:text-white transition-colors"
          >
            <ShoppingBag size={16} /> Shop products
          </Link>
        </div>
        <button
          onClick={() => window.history.back()}
          className="mt-8 inline-flex items-center gap-1 text-sm text-zinc-500 hover:text-[#111111]"
        >
          <ArrowLeft size={14} /> Back to previous page
        </button>
      </div>
    </div>
  );
}
